import api from "./api";
import { LoginCredentials } from "../types/auth";
import { LoginApiResponse } from "../types/api";
import { API_ENDPOINTS } from "./endpoints";
import { ApiResponse } from "../types/api";

const authService = {
  async login(credentials: LoginCredentials): Promise<void> {
    try {
      const response = await api.post<ApiResponse<LoginApiResponse>>(API_ENDPOINTS.AUTH.LOGIN, credentials);
      const { accessToken, refreshToken } = response.data.data;
      authService.setTokens(accessToken, refreshToken);
    } catch (error) {
      throw error;
    }
  },

  logout(): void {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    window.location.href = "/sign-in";
  },

  getAccessToken(): string | null {
    return localStorage.getItem("accessToken");
  },

  getRefreshToken(): string | null {
    return localStorage.getItem("refreshToken");
  },

  setTokens(accessToken: string, refreshToken: string): void {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
  },

  async refreshAccessToken(): Promise<string | null> {
    try {
      const refreshToken = authService.getRefreshToken();
      if (!refreshToken) {
        return null;
      }

      const response = await api.post<ApiResponse<LoginApiResponse>>(API_ENDPOINTS.AUTH.REFRESH, {
        token: refreshToken,
      });
      const { accessToken, refreshToken: newRefreshToken } = response.data.data;
      
      authService.setTokens(accessToken, newRefreshToken);
      return accessToken;
    } catch (error) {
      authService.logout();
      return null;
    }
  },

  isAuthenticated(): boolean {
    const token = authService.getAccessToken();
    return !!token;
  },

  isAdmin(): boolean {
    return localStorage.getItem("userRole") === "admin";
  },

  isHR(): boolean {
    return localStorage.getItem("userRole") === "hr";
  }
};

export default authService;
